<template>
  <div>
    <div class="evolution_left" :class="istabBar?'isFixed':''">
<!--      <div class="evolution_left_txt" v-if="!show">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="evolution_txt">
          {{titlename}} <span class="span1">></span> <span class="span2">{{txt}}</span>
        </div>
      </div> -->
      <div class="evolution_txt1" :class="show?'addstyle':''">{{title}}</div>
      <ul class="evolution_txt2">
        <li v-for="(item,index) in list" :key="index" :class="item.zt?'add':''" @click="dian(item.id,item.txt)">{{item.txt}}</li>
      </ul>
    </div>
    <div class="evolution_left" v-if="istabBar">
      <div class="evolution_txt1" :class="show?'addstyle':''">{{title}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['titlename', 'list', 'txt', 'title','show','ding'],
    data() {
      return {
        middle:{
          brief: false,//杂志简介
          inscription: false,//领导及专家题词
          Deeds: false,//发展大事记
          Awards: false,//获奖情况
          Included: false,//检索机构收录情况
          paper: false,//论文统计与分析
          blessing: false,//祝福集锦
          learning: false,//学术会议
          meeting: false,//编委会会议
        },//中间内容区域展示模块显示隐藏
        istabBar: false,
      }
    },
    methods: {
      //点击切换列表
      dian(id,name) {
        console.log(id,name,'我看看')
        if(this.title=='外科天地'){
          this.middle.video = true;
          this.middle.brief = false;
          this.middle.inscription = false;
          this.middle.Deeds = false;
          this.middle.Awards = false;
          this.middle.Included = false;
          this.middle.paper = false;
          this.middle.blessing = false;
          this.middle.learning = false;
          this.middle.meeting = false;
          this.$emit("dian",this.middle);
          this.$emit("name",name);
        }else if(name=='视频' || name=='课件'){
          this.middle.video = true;
          this.middle.brief = false;
          this.middle.inscription = false;
          this.middle.Deeds = false;
          this.middle.Awards = false;
          this.middle.Included = false;
          this.middle.paper = false;
          this.middle.blessing = false;
          this.middle.learning = false;
          this.middle.meeting = false;
          this.$emit("dian",this.middle);
          this.$emit("name",name);
        }else if(name=='编辑委员会会议'){
          this.middle.video = false;
          this.middle.brief = false;
          this.middle.inscription = false;
          this.middle.Deeds = false;
          this.middle.Awards = false;
          this.middle.Included = false;
          this.middle.paper = false;
          this.middle.blessing = false;
          this.middle.learning = false;
          this.middle.meeting = true;
          this.$emit("dian",this.middle);
          this.$emit("name",name);
        }else{
          if(id==1){
            this.middle.brief = true;
            this.middle.inscription = false;
            this.middle.Deeds = false;
            this.middle.Awards = false;
            this.middle.Included = false;
            this.middle.paper = false;
            this.middle.blessing = false;
            this.middle.learning = false;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            this.$emit("name",name);
          }else if(id==2){
            this.middle.brief = false;
            this.middle.inscription = true;
            this.middle.Deeds = false;
            this.middle.Awards = false;
            this.middle.Included = false;
            this.middle.paper = false;
            this.middle.blessing = false;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            this.$emit("name",name);
          }else if(id==3){
            this.middle.brief = false;
            this.middle.inscription = false;
            this.middle.Deeds = true;
            this.middle.Awards = false;
            this.middle.Included = false;
            this.middle.paper = false;
            this.middle.blessing = false;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            console.log(name,'name!!!!')
            this.$emit("name",name);
          }else if(id==4){
            this.middle.brief = false;
            this.middle.inscription = false;
            this.middle.Deeds = false;
            this.middle.Awards = true;
            this.middle.Included = false;
            this.middle.paper = false;
            this.middle.blessing = false;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            this.$emit("name",name);
          }else if(id==5){
            this.middle.brief = false;
            this.middle.inscription = false;
            this.middle.Deeds = false;
            this.middle.Awards = false;
            this.middle.Included = true;
            this.middle.paper = false;
            this.middle.blessing = false;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            this.$emit("name",name);
          }else if(id==6){
            this.middle.brief = false;
            this.middle.inscription = false;
            this.middle.Deeds = false;
            this.middle.Awards = false;
            this.middle.Included = false;
            this.middle.paper = true;
            this.middle.blessing = false;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            this.$emit("name",name);
          }else if(id==7){
            this.middle.brief = false;
            this.middle.inscription = false;
            this.middle.Deeds = false;
            this.middle.Awards = false;
            this.middle.Included = false;
            this.middle.paper = false;
            this.middle.blessing = true;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            this.$emit("name",name);
          }else if(id==8){
            this.middle.brief = false;
            this.middle.inscription = false;
            this.middle.Deeds = true;
            this.middle.Awards = false;
            this.middle.Included = false;
            this.middle.paper = false;
            this.middle.blessing = false;
            this.middle.meeting = false;
            this.$emit("dian",this.middle);
            this.$emit("name",name);
          }
        }
        for (var i = 0; i < this.list.length; i++) {
          if (id == this.list[i].id) {
            this.list[i].zt = true;
            this.list.push('1');
            this.list.pop('1');
          } else {
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
      //滚动固定导航栏
      handleScroll () {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollTop > 252 && !this.ding){
              this.istabBar = true;
              console.log('执行')
          } else {
              this.istabBar = false;
          }
      },
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll); // Dom树加载完毕
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll) // 销毁页面时清除
    },
    created() {

    }
  }
</script>

<style lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .evolution_left {
    width: 15%;
    float: left;

    .evolution_left_txt {
      width: 100%;
      overflow: hidden;

      .evolution_tu {
        width: 19px;
        height: 17px;
        float: left;
      }

      .evolution_txt {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;

        .span1 {
          margin: 0 5px;
        }

        .span2 {
          color: var(--xt);
        }
      }
    }

    .evolution_txt1 {
      width: 100%;
      line-height: 44px;
      background-color: var(--xt);
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      margin-top: 25px;
    }

    .evolution_txt2 {
      width: 100%;
      list-style: none;

      li {
        width: 100%;
        border-bottom: 1px solid #F0F0F0;
        line-height: 56px;
        text-align: center;
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #000000;
        cursor: pointer;
        background-color: #FFFFFF;
      }
    }
  }

  .add {
    color: var(--xt) !important;
    font-weight: bold !important;
    background-color: var(--bei) !important;
  }
  // .addstyle{
  //   margin-top: 40px!important;
  // }
  .isFixed {
    width: 13%!important;
    position: fixed;
    top: 45px;
    z-index: 10;
    background-color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/evolution/leftbrief.vue